import React from 'react';
import { mval } from './collect';
import { totShares } from './master';
import type { Project, Collect, Master } from './types';
import type { DocViewState } from './DocViewModal';

interface Props {
  p: Project;
  collect: Collect;
  m: Master;
  withAnswers: boolean;
  editM: (fn: (mm: Master) => void) => void;
  onZip: (target: 'org' | 'gp') => void;
  onDocView: (d: DocViewState) => void;
}

export default function MasterFields({ p, collect, m, withAnswers, editM, onZip, onDocView }: Props) {
  const a = (v: string): string | null => (withAnswers ? v : null);
  const ans = (k: string) => mval(collect.gp, k);
  const lpVal = (i: number, k: string): string => (collect.lps[i] ? mval(collect.lps[i], k) : '');
  const aL = (v: string): string | undefined => (withAnswers && v ? v : undefined);
  const numAmt = (s: string): number => parseInt((s || '').replace(/[^0-9]/g, ''), 10) || 0;
  const gpAmt = numAmt(m.gp.amt);
  const lpAmt = m.lps.reduce((acc, l) => acc + numAmt(l.amt), 0);
  const totAmt = numAmt(m.total);
  const sumAmt = gpAmt + lpAmt;

  const chip = (ans?: string | null, onFill?: () => void) => {
    if (ans === undefined || ans === null) return null;
    if (ans === '') return <div className="mans none">고객 미제출</div>;
    return (
      <div className="mans"><span className="manl">고객답변</span><span className="manv">{ans}</span>
        <button className="manb" onClick={onFill}>↤ 가져오기</button></div>
    );
  };
  const mf = (label: string, val: string, set: (v: string) => void, ph?: string) => (
    <div className="mf"><label>{label}</label><input value={val || ''} onChange={(e) => set(e.target.value)} placeholder={ph || ''} /></div>
  );
  const mfA = (label: string, val: string, set: (v: string) => void, ph: string, ans: string | null, onFill: () => void) => (
    <div className="mf"><label>{label}</label><input value={val || ''} onChange={(e) => set(e.target.value)} placeholder={ph || ''} />{chip(ans, onFill)}</div>
  );
  const mfZip = (label: string, val: string, set: (v: string) => void, target: 'org' | 'gp') => (
    <div className="mf"><label>{label}</label><div className="mfz"><input value={val || ''} onChange={(e) => set(e.target.value)} placeholder="우편번호" /><button className="zbtn" onClick={() => onZip(target)}>조회</button></div></div>
  );
  const mfV = (label: string, val: string, set: (v: string) => void, ph: string, onView: () => void, viewLabel: string, ans?: string | null, onFill?: () => void) => (
    <div className="mf"><label>{label}</label><div className="mfv"><input value={val || ''} onChange={(e) => set(e.target.value)} placeholder={ph || ''} /><button className="vbtn" onClick={onView}>{viewLabel}</button></div>{chip(ans, onFill)}</div>
  );

  return (
    <>
      <div className="mgrp">조합 정보</div>
      <div className="mgrid">
        {mfA('조합명', m.org, (v) => editM((mm) => { mm.org = v; }), '', a(p.org), () => editM((mm) => { mm.org = p.org; }))}
        {mfA('조합 소재지', m.addr, (v) => editM((mm) => { mm.addr = v; }), '1단계 매핑 답변', a(ans('orgAddr')), () => { const v = ans('orgAddr'); if (v) editM((mm) => { mm.addr = v; }); })}
        {mfZip('조합 우편번호', m.zip, (v) => editM((mm) => { mm.zip = v; }), 'org')}
        {mfA('출자금 총액(원)', m.total, (v) => editM((mm) => { mm.total = v; }), '', a(p.total), () => editM((mm) => { mm.total = p.total; }))}
        {mf('1좌 금액(원)', m.unit, (v) => editM((mm) => { mm.unit = v; }))}
        {mf('존속기간(년)', m.dur, (v) => editM((mm) => { mm.dur = v; }))}
      </div>
      <div className="mcalc">총 출자좌수 <b>{totShares(m).toLocaleString()}</b>좌 · 출자총액 ÷ 1좌 금액 (금액은 한글·숫자 병기로 자동 생성)</div>
      <div className="mgrp">출자 구성</div>
      <div className="mgrid">{mf('GP 출자금(원)', m.gp.amt, (v) => editM((mm) => { mm.gp.amt = v; }), '예: 50,000,000')}</div>
      {(totAmt > 0 || sumAmt > 0) ? (
        sumAmt === totAmt
          ? <div className="mcalc">✓ 출자 구성 합계 <b>{sumAmt.toLocaleString()}원</b> = 출자총액 · GP {gpAmt.toLocaleString()} + LP {lpAmt.toLocaleString()}</div>
          : <div className="mcalc warn">⚠ 출자 구성 합계가 출자총액과 다릅니다 · GP {gpAmt.toLocaleString()} + LP {lpAmt.toLocaleString()} = <b>{sumAmt.toLocaleString()}원</b> ≠ 출자총액 {totAmt.toLocaleString()}원 (차이 {Math.abs(sumAmt - totAmt).toLocaleString()}원)</div>
      ) : null}
      <div className="mgrp">GP 정보 (업무집행조합원)</div>
      <div className="mgrid">
        {mf('성명', m.gp.name, (v) => editM((mm) => { mm.gp.name = v; }))}
        {mfV('주민등록번호', m.gp.rrn, (v) => editM((mm) => { mm.gp.rrn = v; }), '', () => onDocView({ who: 'gp', i: 0, field: 'rrn', docKey: '신분증 사본', mapKey: 'idCard', label: 'GP 주민등록번호' }), '🪪 신분증 보기', a(ans('gpRrn')), () => { const v = ans('gpRrn'); if (v) editM((mm) => { mm.gp.rrn = v; }); })}
        {mf('전화번호', m.gp.tel, (v) => editM((mm) => { mm.gp.tel = v; }))}
        {mf('이메일', m.gp.email, (v) => editM((mm) => { mm.gp.email = v; }))}
        {mfV('집주소', m.gp.addr, (v) => editM((mm) => { mm.gp.addr = v; }), '', () => onDocView({ who: 'gp', i: 0, field: 'addr', docKey: '주민등록등본', mapKey: 'rrnCopy', label: 'GP 집주소' }), '📄 등본 보기', a(ans('gpAddr')), () => { const v = ans('gpAddr'); if (v) editM((mm) => { mm.gp.addr = v; }); })}
        {mfZip('집 우편번호', m.gp.zip, (v) => editM((mm) => { mm.gp.zip = v; }), 'gp')}
        {mf('최종학력', m.gp.edu, (v) => editM((mm) => { mm.gp.edu = v; }), '예: ○○대학교 ○○학과')}
        {mfA('주요경력', m.gp.career, (v) => editM((mm) => { mm.gp.career = v; }), '(2020~현재) (주)○○ 대표이사', a(ans('gpCareer')), () => { const v = ans('gpCareer'); if (v) editM((mm) => { mm.gp.career = v; }); })}
      </div>
      <div className="mgrp">LP 정보 (유한책임조합원)</div>
      {m.lps.length ? m.lps.map((l, i) => (
        <div className="mgrid lprow" key={i}>
          <div className="lpidx">LP{i + 1}</div>
          {mfA('성명', l.name, (v) => editM((mm) => { mm.lps[i].name = v; }), '', a((collect.lps[i] || { name: '' }).name || ''), () => editM((mm) => { mm.lps[i].name = (collect.lps[i] && collect.lps[i].name) || ''; }))}
          {mfV('주민등록번호', l.rrn, (v) => editM((mm) => { mm.lps[i].rrn = v; }), '', () => onDocView({ who: 'lp', i, field: 'rrn', docKey: '주민등록등본', mapKey: 'rrnCopy', label: 'LP' + (i + 1) + ' 주민등록번호' }), '📄 등본 보기', aL(lpVal(i, 'lpRrn')), () => { const v = lpVal(i, 'lpRrn'); if (v) editM((mm) => { mm.lps[i].rrn = v; }); })}
          {mfV('주소', l.addr, (v) => editM((mm) => { mm.lps[i].addr = v; }), '', () => onDocView({ who: 'lp', i, field: 'addr', docKey: '주민등록등본', mapKey: 'rrnCopy', label: 'LP' + (i + 1) + ' 주소' }), '📄 등본 보기', aL(lpVal(i, 'lpAddr')), () => { const v = lpVal(i, 'lpAddr'); if (v) editM((mm) => { mm.lps[i].addr = v; }); })}
          <div className="lpamt">{mf('출자금(원)', l.amt, (v) => editM((mm) => { mm.lps[i].amt = v; }))}</div>
          <div className="lptel">{mfA('휴대폰번호', l.tel, (v) => editM((mm) => { mm.lps[i].tel = v; }), '', a(lpVal(i, 'lpPhone')), () => { const v = lpVal(i, 'lpPhone'); if (v) editM((mm) => { mm.lps[i].tel = v; }); })}</div>
          <div className="lptel">{mf('소개자 (복수는 쉼표)', l.referrers || '', (v) => editM((mm) => { mm.lps[i].referrers = v; }))}</div>
        </div>
      )) : <div className="snote" style={{ padding: '4px 0' }}>LP 없음 · 1단계에서 &apos;LP 추가&apos; 시 자동 반영</div>}
      <div className="mgrp">교육 정보 (전문성 확인서) · 등록일 기준 자동</div>
      <div className="mgrid">
        {mf('교육명', m.edu.name, (v) => editM((mm) => { mm.edu.name = v; }))}
        {mf('교육기관', m.edu.org, (v) => editM((mm) => { mm.edu.org = v; }))}
        {mf('교육기간', m.edu.period, (v) => editM((mm) => { mm.edu.period = v; }))}
        {mf('교육 이수일', m.edu.date, (v) => editM((mm) => { mm.edu.date = v; }))}
      </div>
    </>
  );
}
